module.exports = __webpack_public_path__ + "img/2_157.e5663d65.png";